import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CatalogViewDto } from '@app/_models/catalogViewDto';
import { BaseTableDataService } from './baseTableData.service';

@Injectable({
  providedIn: 'root',
})
export class CatalogViewService extends BaseTableDataService<CatalogViewDto, number> {
  constructor() {
    super('catalog', 'views');
  }

  getCatalogViews(): Observable<CatalogViewDto[]> {
    return this.http.get<CatalogViewDto[]>(this.baseControllerUrl + '/views/all');
  }

  getUserCatalogViews(): Observable<CatalogViewDto[]> {
    return this.http.get<CatalogViewDto[]>(this.baseControllerUrl + '/views/user');
  }
}
